import React from 'react';
import { IonIcon, IonModal } from '@ionic/react';
import IconButton from '../IconButton/IconButton';
import Message from '../Message/Message';
import Button from '../Button/Button';
import { close } from 'ionicons/icons';
import { useCfgParam } from '../../hooks/useCfgParam';
import './SupportModal.css';
import version from '../../version/version.json';
import { getIsMobile } from '../../utils/helpers';
import useRestartApp from '../../hooks/useRestartApp';

interface SupportModalProps {
  isOpen: boolean;
  closeModal: () => void;
}

const SupportModal = ({ isOpen, closeModal }: SupportModalProps) => {
  const appName = useCfgParam('appName');
  const mobileAppVersion = useCfgParam('mobileAppVersion');
  const isMobile = getIsMobile();
  const appVersion = isMobile ? mobileAppVersion : version.version;
  const { restartApp } = useRestartApp();

  return (
    <IonModal
      isOpen={isOpen}
      className="support-modal"
      onWillDismiss={closeModal}
    >
      <IconButton onClick={closeModal} className="close-button">
        <IonIcon icon={close} />
      </IconButton>
      <div className="support-logo-container ion-padding">
        <img src="/images/logo.svg" alt={appName} />
      </div>
      <div className="content">
        <Message id="endpointHelpModalTitle" as="h2" />
        <h1 className="phone-link">
          <a href="tel:+420257011101">+420 257 011 101</a>
        </h1>
        <Message id={'endpointHelpModalDescription'} as="p" />
      </div>
      <div className="modal-footer">
        <p className="version">MySeptim {appVersion}</p>
        <Button
          className="restart-app-button"
          color="light"
          small
          onClick={restartApp}
        >
          <Message id="restartAppButton" />
        </Button>
      </div>
    </IonModal>
  );
};

export default SupportModal;
